import { Link, Typography } from "@mui/material";
import { DateTime } from "luxon";
import { Links } from "src/constants";
import { FeedItemDto, FeedItemMetricDatapointValueDto } from "src/http";

interface IProps {
  feedItem: FeedItemDto;
}

const MetricDatapointPropertyChange = (props: IProps) => {
  const value = props.feedItem.propertyChange!.value as FeedItemMetricDatapointValueDto;

  return (
    <Typography variant="caption">
      <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
      <span> updated </span>
      <strong>{DateTime.fromISO(value.date).toLocaleString(DateTime.DATE_MED)}</strong>
      <span> datapoint: </span>
      <strong>{value.datapoints.map((x) => `${x.datasetTitle}: ${x.value ?? "(no value)"}`).join(", ")}</strong>
    </Typography>
  );
};

export { MetricDatapointPropertyChange };
